// Turns the payload of the analyticsExport mutation into a file download.
// Text formats arrive as plain strings, binary ones (XLSX) as base64.
export function downloadExport({ filename, contentType, encoding, content }) {
  const body = encoding === 'base64' ? decodeBase64(content) : content;
  const url = URL.createObjectURL(new Blob([body], { type: contentType }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function decodeBase64(content) {
  const binary = atob(content);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

// Downloads a data: URL (e.g. an exported chart image) through a link.
export function downloadDataUrl(dataUrl, filename) {
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

// Renders an exported canvas to PNG and downloads it.
export function downloadCanvasAsPng(canvas, filename) {
  downloadDataUrl(canvas.toDataURL('image/png'), filename);
}
